import React from 'react';

type Props = { isNavVisible: boolean };

const SVBottomMarginContainer = ({ isNavVisible }: Props) => {
	return <>{isNavVisible ? <div className="pointer-events-none h-20" /> : null}</>;
};

export default SVBottomMarginContainer;
